export const PRODUCTION: string = 'production';

export const STORE_ERROR: string = 'STORE_ERROR';
export const CLOSE_ERROR: string = 'CLOSE_ERROR';

export const SET_LANGUAGE: string = 'SET_LANGUAGE';
export const APP_DATA: string = 'APP_DATA';

export const SET_ENGINE: string = 'SET_ENGINE';
export const SET_PAINT: string = 'SET_PAINT';
export const SET_COLORS: string = 'SET_COLORS';
export const SET_SELECTED_COLOR: string = 'SET_SELECTED_COLOR';
// export const SET_CHANGE_COLOR: string = 'SET_CHANGE_COLOR';
export const SET_CURRENT_COLOR: string = 'SET_CURRENT_COLOR';
export const SET_MENU: string = 'SET_MENU';
export const SET_BLADES: string = 'SET_BLADES';

export const SET_ROTATION: string = 'SET_ROTATION';
export const SET_PROPELLER: string = 'SET_PROPELLER';
export const SET_PLATFORM: string = 'SET_PLATFORM';
export const SET_WINGLIGHT: string = 'SET_WINGLIGHT';
export const SET_WHEELS: string = 'SET_WHEELS';
export const SET_SKY: string = 'SET_SKY';

export const LABEL_DATA: string = 'LABEL_DATA';
